import { Injectable } from '@angular/core';
import { IStaticDropdownData } from '../../models/common/interfaces/IStaticDropdownData';
import { BaseHttpService } from "./base-http.service";

@Injectable({
  providedIn: 'root'
})
export class StaticDropdownAPIService {

  constructor(private baseHttp: BaseHttpService) {}

  loadData() {
    return this.baseHttp.get<IStaticDropdownData>('assets/data/preference-properties-static-dropdown-data.json');
  }
}
